import { render, staticRenderFns } from "./ActivityBaseForm.vue?vue&type=template&id=4bd4241c&"
import script from "./ActivityBaseForm.vue?vue&type=script&lang=js&"
export * from "./ActivityBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports